/*!

=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import NewConversationButton from '../Misc/NewConversationButton';
import BackendEnvironment from '../Misc/BackendEnvironment';

// reactstrap components
import { Navbar, Nav, Container } from 'reactstrap';
import DynamicSearchBox from 'components/Misc/DynamicSearchBox';

const UserNavbar = (props) => {
  // TODO: Make the Plus button work
  // Rather than droping down it should open a new view with a form to add a new client/start recording a conversation
  // I'd say probably add a new Conversation view
  // When we add a new conversations we should auto complete the client name and the date based on the dialog potentially?
  // /User/conversation#convoID should be the route
  // Make the conversations clickable
  // Make the Patients clickable
  // Make the conversations sortable based on patient name, date, etc (Use the route to sort)
  //

  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <BackendEnvironment brandText={props.brandText} />
          <DynamicSearchBox />

          <Nav className="align-items-center d-none d-md-flex" navbar>
            <NewConversationButton id="new-conversation-button-navbar" />
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default UserNavbar;
